// Updated by Vani 30th Sept 2025 v1.0.1
import React, { useEffect, useRef, useState } from "react";
import "./style.css";
 
function Transformbusiness() {
  const sectionRef = useRef(null);
  const [inView, setInView] = useState(false);
 
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true);
          observer.unobserve(entry.target); // Trigger only once
        }
      },
      { threshold: 0.2 }
    );
 
    if (sectionRef.current) observer.observe(sectionRef.current);
 
    return () => {
      if (sectionRef.current) observer.unobserve(sectionRef.current);
    };
  }, []);
 
  return (
    <div className="transform-wrapper" ref={sectionRef}>
      <div className="transform-business-container">
        <div
          className={`transform-business-left-container ${inView ? "animated-video delay-0" : ""
            }`}
        >
          <video className="freepik-video" muted loop autoPlay playsInline>
            <source src="https://namodeva-images.s3.ap-south-1.amazonaws.com/equinox/videos/Morphing+Square-.mp4" type="video/mp4" />
          </video>
        </div>
 
        <div className="transform-business-right-container">
          <div
            className={`transform-text ${inView ? "animated-line delay-0" : ""
              }`}
          >
            Shaping the Future of  Business with
            <p className="heighlight-text" style={{ fontWeight: "900" }}>
              Tech Solutions
            </p>
 
          </div>
 
          <blockquote
            className={`transform-description ${inView ? "animated-line delay-2" : ""
              }`}
          >
            "The technology you use impresses no one.<br />The experience
            you create with it is everything."
             <br />
            
          </blockquote>
          
          {/* <p className={`sean-text ${inView ? "animated-line delay-3" : ""}`}>
           --- Sean Gerety
          </p> */}
 
          <div className="digital-exp">
            <div
              className={`heighlight-text seven-styles ${inView ? "animated-line delay-4" : ""
                }`}
              style={{ fontSize: "8.25rem", fontWeight: "900" }}
            >
              7
            </div>
            <br />
            <span className={`${inView ? "animated-line delay-5" : ""}`}>
              YEARS OF <br />
              DIGITAL EXPERIENCE
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
 
export default Transformbusiness;
